import { useRouter } from "next/router";
import constants from "../utils/constants";

function useCheckViewerPage() {
  const { pathname } = useRouter();

  if (pathname.includes(constants.SCREENS.VIEWER)) {
    return true;
  }
  return false;
}

export default useCheckViewerPage;
